import React, {Component} from 'react';
import ReactGA from 'react-ga';

import AlertSection from '../containers/AlertSection/AlertSection';
import FooterSection from '../containers/FooterSection/FooterSection';
import PatentsPage from '../pages/PatentsPage/PatentsPage';
import ApplicationsPage from '../pages/ApplicationsPage/ApplicationsPage';
import FaqPage from '../pages/FaqPage/FaqPage';
import ContactPage from '../pages/ContactPage/ContactPage';
import ContactRemoteRxPage from '../pages/ContactRemoteRxPage/ContactRemoteRxPage';
import UpdatesPage from '../pages/UpdatesPage/UpdatesPage';
import RemoteRxPage from '../pages/RemoteRxPage/RemoteRxPage';
import MetaverseHealthPage from '../pages/MetaverseHealthPage/MetaverseHealthPage';
import VirusPage from '../pages/VirusPage/VirusPage';
import MarketPage from '../pages/MarketPage/MarketPage';
import VideosPage from '../pages/VideosPage/VideosPage';
import PrivacyPage from '../pages/PrivacyPage/PrivacyPage';
import TermsPage from '../pages/TermsPage/TermsPage';

import { Route, Switch } from 'react-router-dom';
import App from '../containers/App';

class RouterIndex extends Component {
   constructor(props){
      super(props);
      ReactGA.initialize('UA-117828931-1');
   }
   render(){
      return (
         <div>
            <AlertSection />
            <Switch>
               <Route exact path="/" render={()=><App pageOn="whatis" />}  />
               <Route path="/applications" render={()=><ApplicationsPage pageOn="applications" />}  />
               <Route path="/contact" render={()=><ContactPage pageOn="contact" />}  />
               <Route path="/contactremoterx" render={()=><ContactRemoteRxPage pageOn="contactremoterx" />}  />
               <Route path="/faq" render={()=><FaqPage pageOn="faq" />}  />
               <Route path="/market" render={()=><MarketPage pageOn="market" />} />
               <Route path="/patents" render={()=><PatentsPage pageOn="patents" />}  />
               <Route path="/updates" render={()=><UpdatesPage pageOn="updates" />}  />
               <Route path="/remoterx" render={()=><RemoteRxPage pageOn="remoterx" />}  />
               <Route path="/metaversehealth" render={()=><MetaverseHealthPage pageOn="metaversehealth" />}  />
               <Route path="/covid19" render={()=><VirusPage pageOn="covid19" />}  />
               <Route path="/videos" render={()=><VideosPage pageOn="videos" />}  />
               <Route path="/privacy" render={()=><PrivacyPage pageOn="privacy" />}  />
               <Route path="/terms" render={()=><TermsPage pageOn="terms" />}  />
               {/* <Route path="/market" component={MarketPage} pageOn="market" /> */}
            </Switch>
            <FooterSection />
            
      
         </div>
      )
   }
}

export default RouterIndex;


// WEBPACK FOOTER //
// ./src/pages/RouterIndex.js